﻿import { RESTError } from "../API/RESTError";
import { resetPassword } from "../API/Users/Users";
import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";

export class PasswordResetPage implements IPage {
    
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'changePassword';

    public initialize(): void {

    }

    private container: JQuery = null;
    
    private submitButton: JQuery = null;
    private inputValidation: boolean = false;
    private inputValidationWarningContainer: JQuery = null;
    private validationCompleteAllFields: JQuery = null;
    private validationInvalidNewPasswords: JQuery = null;
    private passwordResetError: JQuery = null;
    private newPasswordContainer1: JQuery = null;
    private newPasswordContainer2: JQuery = null;
    private oldPasswordContainer: JQuery = null;
    private passwordResetSuccess: JQuery = null;
    private formBox: JQuery = null;
    private returntoPreviousPageOrCancel: JQuery = null;
    private oldPasswordInput: JQuery = null;
    private newPasswordInput1: JQuery = null;
    private newPasswordInput2: JQuery = null;
    

    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                this.render();
            }
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    
    //public currentUser: UserAccount;

    public render(): void {
        this.container = $('<div class="container"></div>').appendTo('body');

        $('<h1>Change Password</h1>').appendTo(this.container);

        $('<p>Use the form below to change your password.</p><p>If you have forgotten your password, then please log out and click <strong>Forgotten your password</strong> on the log in page to recieve a new one.</p>').appendTo(this.container);

        this.formBox = $('<div class="col-md-6"></div>').appendTo(
            $('<div class="row"></div>').appendTo(this.container));

        this.oldPasswordContainer = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">Old Password:</span>').appendTo(this.oldPasswordContainer);
        this.oldPasswordInput = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.oldPasswordContainer);

        this.newPasswordContainer1 = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">New Password:</span>').appendTo(this.newPasswordContainer1);
        this.newPasswordInput1 = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.newPasswordContainer1);

        this.newPasswordContainer2 = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">Confirm New Password:</span>').appendTo(this.newPasswordContainer2);
        this.newPasswordInput2 = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.newPasswordContainer2);


        $('<button type="button" class="btn btn-success midi_PasswordResetPage_button">Change Password</button>')
            .appendTo($('<div></div>').appendTo(this.formBox))
            .click(() => {
                this.checkInputs();
                if (this.inputValidation) {
                    this.tryPasswordReset(MainSite.instance.currentUser.Id, this.oldPasswordInput.val(), this.newPasswordInput1.val());
                }
            });

        this.returntoPreviousPageOrCancel = $('<div class="midi_common_link">Cancel</div>')
            .appendTo(this.formBox)
            .click(() => {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            window.history.back();
            });

        this.inputValidationWarningContainer = $('<div class="alert midi_PasswordResetPage_input_warning_container"></div>').appendTo(this.formBox).hide();
    }
    
    //public staticDataManager: StaticDataManager = new StaticDataManager();

    private tryPasswordReset(email: string, oldPassword: string, newPassword: string): void {
        resetPassword(email, oldPassword, newPassword,(err: RESTError) => { // register user or if error then render the page again or try again
            this.inputValidationWarningContainer.empty().hide();
            this.inputValidationWarningContainer.removeClass("alert-danger").removeClass("alert-success");
            if (err) {
                // there has been an error reseting the password
                this.inputValidationWarningContainer.addClass("alert-danger");
                this.inputValidationWarningContainer.show();
                this.passwordResetError = $('<div class="midi_common_validation_text_container_warning">Error changing password: ' + err.Message + '</div>').appendTo(this.inputValidationWarningContainer);
                //is there a nicer way to clear the input boxes? apparently can't do .reset()
                
                
                
            } else {
                // password reset has worked
                this.inputValidationWarningContainer.addClass("alert-success");
                this.inputValidationWarningContainer.show();
                this.passwordResetSuccess = $('<div class="midi_PasswordResetPage_input_warning_container">Password reset was successful.</div>').appendTo(this.inputValidationWarningContainer);

                this.returntoPreviousPageOrCancel.text("Return to Previous Page");
            }
            $('.midi_PasswordResetPage_password_input').val("");
        });
    }

    private checkInputs(): void {
        this.inputValidation = true;
        this.inputValidationWarningContainer.empty();
        this.inputValidationWarningContainer.show();
        if (!this.oldPasswordInput.val() || !this.newPasswordInput1.val() || !this.newPasswordInput2.val()) {
            this.validationCompleteAllFields = $('<div class="midi_common_validation_text_container_warning">Please complete all fields.</div>').appendTo(this.inputValidationWarningContainer);
            this.inputValidation = false;
        }
        
        if (!this.oldPasswordInput.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.oldPasswordInput.addClass("midi_common_validation_warning");
        }
        else {
            this.oldPasswordInput.removeClass("midi_common_validation_warning");
        }
        if (!this.newPasswordInput1.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.newPasswordInput1.addClass("midi_common_validation_warning");
        }
        else {
            this.newPasswordInput1.removeClass("midi_common_validation_warning");
        }
        if (!this.newPasswordInput2.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.newPasswordInput2.addClass("midi_common_validation_warning");
        }
        else {
            this.newPasswordInput2.removeClass("midi_common_validation_warning");
        }
        if (this.newPasswordInput1.val() !== this.newPasswordInput2.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.validationInvalidNewPasswords = $('<div class="midi_common_validation_text_container_warning">Passwords do not match, please re-enter.</div>').appendTo(this.inputValidationWarningContainer);
            this.inputValidation = false;

            this.newPasswordInput1.val("").addClass("midi_common_validation_warning");
            this.newPasswordInput2.val("").addClass("midi_common_validation_warning");

        }
    }
}